import React from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.less';

const propsByVersion = {
  default: {
    className: styles.default,
  },
};

const RangePicker = ({ version, className, ...rest }) => {
  const { RangePicker: AntRangePicker } = DatePicker;
  const { className: propsClassName = '', ...props } = propsByVersion[version];

  return <AntRangePicker {...props} className={`${propsClassName} ${className}`} {...rest} />;
};

RangePicker.propTypes = {
  version: PropTypes.oneOf(['default']),
  className: PropTypes.string,
};

RangePicker.defaultProps = {
  version: 'default',
  className: '',
};

export default RangePicker;
